import { gql } from '@apollo/client';

const GET_CURRENT_USER_EVENT_BID = gql`
  query GetCurrentUserEventBid($eventId: Int!) {
    currentUserEventBid(eventId: $eventId) {
      EventId
      CanBidForEvent
      BidStatus {
        Id
        BidDate
      }
    }
  }
`;

export default GET_CURRENT_USER_EVENT_BID;
